import { ref } from 'vue';

export function createScreenShareState() {
  const isScreenSharing = ref(false);

  function markScreenSharingActive() {
    isScreenSharing.value = true;
  }

  function markScreenSharingInactive() {
    isScreenSharing.value = false;
  }

  return {
    isScreenSharing,
    markScreenSharingActive,
    markScreenSharingInactive,
  };
}
